import { useSession } from 'next-auth/react'
import { useEventListener, useUpdateEffect } from 'ahooks'


import { useState, useMemo } from 'react';
export const AUTH_LOGIN_EVENT = 'AUTH_LOGIN'
export const AUTH_LOGOUT_EVENT = 'AUTH_LOGOUT'
export const AUTH_SWITCH_USER_EVENT = 'AUTH_SWITCH_USER'

interface AuthEventDetail {
  email?: string | null
}

const dispatchAuthEvent = (name: string, detail?: AuthEventDetail) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(name, { detail }))
}

/**
 * 监听用户登录状态变化，并触发事件
 */
export function useAuthStatusEvents() {
  const { status, data } = useSession()

  const userEmailKey = 'user_email'

  useUpdateEffect(() => {
    if (status && status !== 'loading') {
      const userEmail = localStorage.getItem(userEmailKey) || ''
      const currentEmail = data?.user?.email || ''

      if (status === 'authenticated' && data) {
        if (userEmail === currentEmail) {
          dispatchAuthEvent(AUTH_LOGIN_EVENT, {
            email: currentEmail ?? null,
          })
          window.userAuthEventType = AUTH_LOGIN_EVENT
        } else {
          dispatchAuthEvent(AUTH_SWITCH_USER_EVENT, {
            email: currentEmail ?? null,
          })
          window.userAuthEventType = AUTH_SWITCH_USER_EVENT
        }
        localStorage.setItem(userEmailKey, currentEmail)
      }

      if (status === 'unauthenticated' && userEmail !== currentEmail) {
        dispatchAuthEvent(AUTH_LOGOUT_EVENT)
        localStorage.setItem(userEmailKey, currentEmail)
        window.userAuthEventType = AUTH_LOGOUT_EVENT
      }
    }
  }, [status, data])
}

export function AuthStatusEventBridge() {
  useAuthStatusEvents()
  return null
}

interface UseAuthStatusEventListenProps {
  onLogin?: () => void
  onSwitchUser?: () => void
  onLogout?: () => void
}
export function useAuthStatusEventListen(props: UseAuthStatusEventListenProps) {
  const { onLogin, onSwitchUser, onLogout } = props
  const [_authEventIsReady, setAuthEventIsReady] = useState(false)

  useEventListener(AUTH_LOGIN_EVENT, () => {
    onLogin?.()
    setAuthEventIsReady(true)
  })

  useEventListener(AUTH_SWITCH_USER_EVENT, () => {
    onSwitchUser?.()
    setAuthEventIsReady(true)
  })

  useEventListener(AUTH_LOGOUT_EVENT, () => {
    onLogout?.()
    setAuthEventIsReady(true)
  })

  const authEventIsReady = useMemo(() => {
    if (typeof window === 'undefined') return false
    return !!window.userAuthEventType || _authEventIsReady
  }, [_authEventIsReady])

  return {
    authEventIsReady,
  }
}
